import { render } from "./BannerCreating.vue?vue&type=template&id=677e59cd&ts=true"
import script from "./BannerCreating.vue?vue&type=script&lang=ts"
export * from "./BannerCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__